import {
  SET_ORDER,
  SET_ORDERS,
  SET_WORKSCREEN_ORDERS,
  SET_WORKCARD_ORDER,
  SET_ORDERS_ERRORS,
  // SET_ORDER_FILTER,
  SET_ORDERLIST_FILTER,
  SET_WORKSCREEN_ORDER_FILTER,
  SET_CUSTOMER_ORDER_FILTER,
  SET_WP_ORDER_FILTER,
  // RESET_ORDER_FILTER,
  RESET_ORDERLIST_FILTER,
  RESET_WORKSCREEN_ORDER_FILTER,
  RESET_CUSTOMER_ORDER_FILTER,
  RESET_WP_ORDER_FILTER,
  SET_SIMPLESEARCH,
  SET_SIMPLESEARCH_WORKSCREEN,
  RESET_SIMPLESEARCH,
  RESET_SIMPLESEARCH_WORKSCREEN,
  SET_ORDERS_SEARCH,
  SET_LAST_VISITED_ORDER,
  SET_ORDER_BOOKING_TIMES
} from '../constants'

const initialState = {
  order: {},
  workcardOrder: {},
  orders: [],
  workscreenOrders: [],
  errors: false,

  filterOrderlist: {
    process: {
      draft: true,
      draft1: false,
      draft2: true,
      InProcess: true,
      Completed: false,
      CompletedThisWeek: true
    },
    external_control: 'all',
    invoicing: 'all',
    evaluation: {
      missing: false,
      evaluated: false
    },
    update: {
      missing: false,
      updated: false
    },
    customergroup: {
      CustomerGroupId: -1,
      CustomerGroupName: ''
    },
    pricemodel: {
      PriceModelId: -1,
      PriceModelName: ''
    },
    orderType: '0',
    identification: {
      ordernumber: {
        value: '',
        option: 1
      },
      rekvnumber: {
        value: '',
        option: 1
      }
    },
    delivery: {
      delivery: {
        start: '',
        end: ''
      },
      production: {
        start: '',
        end: ''
      },
      pickup: {
        start: '',
        end: ''
      },
      transport: 0
    },
    vehicle: {
      regnumber: {
        value: '',
        option: 1
      },
      brand: {
        value: '',
        option: 1
      },
      model: {
        value: '',
        option: 1
      },
      year: {
        value: '',
        option: 1
      }
    },
    color: {
      color: {
        value: '',
        option: 1
      },
      code: {
        value: '',
        option: 1
      },
      ctype: {
        value: '',
        option: 1
      },
      amount: {
        value: '',
        option: 1
      }
    },
    customer: {
      name: {
        value: '',
        option: 1
      },
      city: {
        value: '',
        option: 1
      },
      zipcode: {
        value: '',
        option: 1
      },
      phone: {
        value: '',
        option: 1
      },
      contact_name: {
        value: '',
        option: 1
      }
    },
    invoice: {
      notApprovedForInvoicing: false,
      approvedForInvoicing: false,
      isInvoiced: false
    },
    economicfilter: {
      economicFilterNotMatched: false,
      economicFilterMatched: false
    },
    additionalreport: {
      awaiting: false,
      received: false
    },
    movedOrders: true,
    parts: {
      bodyNotOrdered: false,
      bodyOrdered: false,
      bodyInStock: false,
      bodyArrived: false,
      paintNotOrdered: false,
      paintOrdered: false,
      paintInStock: false,
      paintArrived: false
    },
    HasPaintWork: true,
    HasBodyWork: true,
    NewOrdersFilter: 0,
    AssignedToMe: false
  },
  filterWorkscreen: {
    process: {
      draft: false, // true,
      draft1: false,
      draft2: true,
      InProcess: true,
      Completed: false,
      CompletedThisWeek: false // true
    },
    external_control: 'all',
    invoicing: 'all',
    evaluation: {
      missing: false,
      evaluated: false
    },
    update: {
      missing: false,
      updated: false
    },
    customergroup: {
      CustomerGroupId: -1,
      CustomerGroupName: ''
    },
    pricemodel: {
      PriceModelId: -1,
      PriceModelName: ''
    },
    orderType: '0',
    identification: {
      ordernumber: {
        value: '',
        option: 1
      },
      rekvnumber: {
        value: '',
        option: 1
      }
    },
    delivery: {
      delivery: {
        start: '',
        end: ''
      },
      production: {
        start: '',
        end: ''
      },
      pickup: {
        start: '',
        end: ''
      },
      transport: 0
    },
    vehicle: {
      regnumber: {
        value: '',
        option: 1
      },
      brand: {
        value: '',
        option: 1
      },
      model: {
        value: '',
        option: 1
      },
      year: {
        value: '',
        option: 1
      }
    },
    color: {
      color: {
        value: '',
        option: 1
      },
      code: {
        value: '',
        option: 1
      },
      ctype: {
        value: '',
        option: 1
      },
      amount: {
        value: '',
        option: 1
      }
    },
    customer: {
      name: {
        value: '',
        option: 1
      },
      city: {
        value: '',
        option: 1
      },
      zipcode: {
        value: '',
        option: 1
      },
      phone: {
        value: '',
        option: 1
      },
      contact_name: {
        value: '',
        option: 1
      }
    },
    invoice: {
      notApprovedForInvoicing: false,
      approvedForInvoicing: false,
      isInvoiced: false
    },
    economicfilter: {
      economicFilterNotMatched: false,
      economicFilterMatched: false
    },
    additionalreport: {
      awaiting: false,
      received: false
    },
    movedOrders: false,
    parts: {
      bodyNotOrdered: false,
      bodyOrdered: false,
      bodyInStock: false,
      bodyArrived: false,
      paintNotOrdered: false,
      paintOrdered: false,
      paintInStock: false,
      paintArrived: false
    },
    HasPaintWork: true,
    HasBodyWork: true,
    NewOrdersFilter: 0,
    AssignedToMe: false
  },
  filterCustomer: {
    process: {
      draft: true,
      draft1: false,
      draft2: true,
      InProcess: true,
      Completed: false,
      CompletedThisWeek: false
    },
    external_control: 'all',
    invoicing: 'all',
    evaluation: {
      missing: false,
      evaluated: false
    },
    update: {
      missing: false,
      updated: false
    },
    customergroup: {
      CustomerGroupId: -1,
      CustomerGroupName: ''
    },
    pricemodel: {
      PriceModelId: -1,
      PriceModelName: ''
    },
    orderType: '0',
    identification: {
      ordernumber: {
        value: '',
        option: 1
      },
      rekvnumber: {
        value: '',
        option: 1
      }
    },
    delivery: {
      delivery: {
        start: '',
        end: ''
      },
      production: {
        start: '',
        end: ''
      },
      pickup: {
        start: '',
        end: ''
      },
      transport: 0
    },
    vehicle: {
      regnumber: {
        value: '',
        option: 1
      },
      brand: {
        value: '',
        option: 1
      },
      model: {
        value: '',
        option: 1
      },
      year: {
        value: '',
        option: 1
      }
    },
    color: {
      color: {
        value: '',
        option: 1
      },
      code: {
        value: '',
        option: 1
      },
      ctype: {
        value: '',
        option: 1
      },
      amount: {
        value: '',
        option: 1
      }
    },
    customer: {
      name: {
        value: '',
        option: 1
      },
      city: {
        value: '',
        option: 1
      },
      zipcode: {
        value: '',
        option: 1
      },
      phone: {
        value: '',
        option: 1
      },
      contact_name: {
        value: '',
        option: 1
      }
    },
    invoice: {
      notApprovedForInvoicing: false,
      approvedForInvoicing: false,
      isInvoiced: false
    },
    economicfilter: {
      economicFilterNotMatched: false,
      economicFilterMatched: false
    },
    additionalreport: {
      awaiting: false,
      received: false
    },
    movedOrders: true,
    parts: {
      bodyNotOrdered: false,
      bodyOrdered: false,
      bodyInStock: false,
      bodyArrived: false,
      paintNotOrdered: false,
      paintOrdered: false,
      paintInStock: false,
      paintArrived: false
    },
    HasPaintWork: true,
    HasBodyWork: true,
    NewOrdersFilter: 0
  },
  filterWP: {
    process: {
      draft: false,
      draft1: false,
      draft2: false,
      InProcess: true,
      Completed: false,
      CompletedThisWeek: true
    },
    external_control: 'all',
    invoicing: 'all',
    evaluation: {
      missing: false,
      evaluated: false
    },
    update: {
      missing: false,
      updated: false
    },
    customergroup: {
      CustomerGroupId: -1,
      CustomerGroupName: ''
    },
    pricemodel: {
      PriceModelId: -1,
      PriceModelName: ''
    },
    orderType: '0',
    identification: {
      ordernumber: {
        value: '',
        option: 1
      },
      rekvnumber: {
        value: '',
        option: 1
      }
    },
    delivery: {
      delivery: {
        start: '',
        end: ''
      },
      production: {
        start: '',
        end: ''
      },
      pickup: {
        start: '',
        end: ''
      },
      transport: 0
    },
    vehicle: {
      regnumber: {
        value: '',
        option: 1
      },
      brand: {
        value: '',
        option: 1
      },
      model: {
        value: '',
        option: 1
      },
      year: {
        value: '',
        option: 1
      }
    },
    color: {
      color: {
        value: '',
        option: 1
      },
      code: {
        value: '',
        option: 1
      },
      ctype: {
        value: '',
        option: 1
      },
      amount: {
        value: '',
        option: 1
      }
    },
    customer: {
      name: {
        value: '',
        option: 1
      },
      city: {
        value: '',
        option: 1
      },
      zipcode: {
        value: '',
        option: 1
      },
      phone: {
        value: '',
        option: 1
      },
      contact_name: {
        value: '',
        option: 1
      }
    },
    invoice: {
      notApprovedForInvoicing: false,
      approvedForInvoicing: false,
      isInvoiced: false
    },
    economicfilter: {
      economicFilterNotMatched: false,
      economicFilterMatched: false
    },
    additionalreport: {
      awaiting: false,
      received: false
    },
    movedOrders: true,
    parts: {
      bodyNotOrdered: false,
      bodyOrdered: false,
      bodyInStock: false,
      bodyArrived: false,
      paintNotOrdered: false,
      paintOrdered: false,
      paintInStock: false,
      paintArrived: false
    },
    HasPaintWork: true,
    HasBodyWork: true,
    NewOrdersFilter: 0
  },
  initialFilterOrderlist: {
    process: {
      draft: true,
      draft1: false,
      draft2: true,
      InProcess: true,
      Completed: false,
      CompletedThisWeek: true
    },
    external_control: 'all',
    invoicing: 'all',
    evaluation: {
      missing: false,
      evaluated: false
    },
    update: {
      missing: false,
      updated: false
    },
    customergroup: {
      CustomerGroupId: -1,
      CustomerGroupName: ''
    },
    pricemodel: {
      PriceModelId: -1,
      PriceModelName: ''
    },
    orderType: '0',
    identification: {
      ordernumber: {
        value: '',
        option: 1
      },
      rekvnumber: {
        value: '',
        option: 1
      }
    },
    delivery: {
      delivery: {
        start: '',
        end: ''
      },
      production: {
        start: '',
        end: ''
      },
      pickup: {
        start: '',
        end: ''
      },
      transport: 0
    },
    vehicle: {
      regnumber: {
        value: '',
        option: 1
      },
      brand: {
        value: '',
        option: 1
      },
      model: {
        value: '',
        option: 1
      },
      year: {
        value: '',
        option: 1
      }
    },
    color: {
      color: {
        value: '',
        option: 1
      },
      code: {
        value: '',
        option: 1
      },
      ctype: {
        value: '',
        option: 1
      },
      amount: {
        value: '',
        option: 1
      }
    },
    customer: {
      name: {
        value: '',
        option: 1
      },
      city: {
        value: '',
        option: 1
      },
      zipcode: {
        value: '',
        option: 1
      },
      phone: {
        value: '',
        option: 1
      },
      contact_name: {
        value: '',
        option: 1
      }
    },
    invoice: {
      notApprovedForInvoicing: false,
      approvedForInvoicing: false,
      isInvoiced: false
    },
    economicfilter: {
      economicFilterNotMatched: false,
      economicFilterMatched: false
    },
    additionalreport: {
      awaiting: false,
      received: false
    },
    movedOrders: true,
    parts: {
      bodyNotOrdered: false,
      bodyOrdered: false,
      bodyInStock: false,
      bodyArrived: false,
      paintNotOrdered: false,
      paintOrdered: false,
      paintInStock: false,
      paintArrived: false
    },
    HasPaintWork: true,
    HasBodyWork: true,
    NewOrdersFilter: 0,
    AssignedToMe: false
  },
  initialFilterWorkscreen: {
    // INITIAL_WORKSCREEN: 'yep',
    process: {
      draft: false, // true
      draft1: false,
      draft2: true,
      InProcess: true,
      Completed: false,
      CompletedThisWeek: false // true
    },
    external_control: 'all',
    invoicing: 'all',
    evaluation: {
      missing: false,
      evaluated: false
    },
    update: {
      missing: false,
      updated: false
    },
    customergroup: {
      CustomerGroupId: -1,
      CustomerGroupName: ''
    },
    pricemodel: {
      PriceModelId: -1,
      PriceModelName: ''
    },
    orderType: '0',
    identification: {
      ordernumber: {
        value: '',
        option: 1
      },
      rekvnumber: {
        value: '',
        option: 1
      }
    },
    delivery: {
      delivery: {
        start: '',
        end: ''
      },
      production: {
        start: '',
        end: ''
      },
      pickup: {
        start: '',
        end: ''
      },
      transport: 0
    },
    vehicle: {
      regnumber: {
        value: '',
        option: 1
      },
      brand: {
        value: '',
        option: 1
      },
      model: {
        value: '',
        option: 1
      },
      year: {
        value: '',
        option: 1
      }
    },
    color: {
      color: {
        value: '',
        option: 1
      },
      code: {
        value: '',
        option: 1
      },
      ctype: {
        value: '',
        option: 1
      },
      amount: {
        value: '',
        option: 1
      }
    },
    customer: {
      name: {
        value: '',
        option: 1
      },
      city: {
        value: '',
        option: 1
      },
      zipcode: {
        value: '',
        option: 1
      },
      phone: {
        value: '',
        option: 1
      },
      contact_name: {
        value: '',
        option: 1
      }
    },
    invoice: {
      notApprovedForInvoicing: false,
      approvedForInvoicing: false,
      isInvoiced: false
    },
    economicfilter: {
      economicFilterNotMatched: false,
      economicFilterMatched: false
    },
    additionalreport: {
      awaiting: false,
      received: false
    },
    movedOrders: false,
    parts: {
      bodyNotOrdered: false,
      bodyOrdered: false,
      bodyInStock: false,
      bodyArrived: false,
      paintNotOrdered: false,
      paintOrdered: false,
      paintInStock: false,
      paintArrived: false
    },
    HasPaintWork: true,
    HasBodyWork: true,
    NewOrdersFilter: 0,
    AssignedToMe: false
  },
  initialFilterCustomer: {
    process: {
      draft: true,
      draft1: false,
      draft2: true,
      InProcess: true,
      Completed: false,
      CompletedThisWeek: false
    },
    external_control: 'all',
    invoicing: 'all',
    evaluation: {
      missing: false,
      evaluated: false
    },
    update: {
      missing: false,
      updated: false
    },
    customergroup: {
      CustomerGroupId: -1,
      CustomerGroupName: ''
    },
    pricemodel: {
      PriceModelId: -1,
      PriceModelName: ''
    },
    orderType: '0',
    identification: {
      ordernumber: {
        value: '',
        option: 1
      },
      rekvnumber: {
        value: '',
        option: 1
      }
    },
    delivery: {
      delivery: {
        start: '',
        end: ''
      },
      production: {
        start: '',
        end: ''
      },
      pickup: {
        start: '',
        end: ''
      },
      transport: 0
    },
    vehicle: {
      regnumber: {
        value: '',
        option: 1
      },
      brand: {
        value: '',
        option: 1
      },
      model: {
        value: '',
        option: 1
      },
      year: {
        value: '',
        option: 1
      }
    },
    color: {
      color: {
        value: '',
        option: 1
      },
      code: {
        value: '',
        option: 1
      },
      ctype: {
        value: '',
        option: 1
      },
      amount: {
        value: '',
        option: 1
      }
    },
    customer: {
      name: {
        value: '',
        option: 1
      },
      city: {
        value: '',
        option: 1
      },
      zipcode: {
        value: '',
        option: 1
      },
      phone: {
        value: '',
        option: 1
      },
      contact_name: {
        value: '',
        option: 1
      }
    },
    invoice: {
      notApprovedForInvoicing: false,
      approvedForInvoicing: false,
      isInvoiced: false
    },
    economicfilter: {
      economicFilterNotMatched: false,
      economicFilterMatched: false
    },
    additionalreport: {
      awaiting: false,
      received: false
    },
    movedOrders: true,
    parts: {
      bodyNotOrdered: false,
      bodyOrdered: false,
      bodyInStock: false,
      bodyArrived: false,
      paintNotOrdered: false,
      paintOrdered: false,
      paintInStock: false,
      paintArrived: false
    },
    HasPaintWork: true,
    HasBodyWork: true,
    NewOrdersFilter: 0
  },
  initialFilterWP: {
    process: {
      draft: false,
      draft1: false,
      draft2: false,
      InProcess: true,
      Completed: false,
      CompletedThisWeek: true
    },
    external_control: 'all',
    invoicing: 'all',
    evaluation: {
      missing: false,
      evaluated: false
    },
    update: {
      missing: false,
      updated: false
    },
    customergroup: {
      CustomerGroupId: -1,
      CustomerGroupName: ''
    },
    pricemodel: {
      PriceModelId: -1,
      PriceModelName: ''
    },
    orderType: '0',
    identification: {
      ordernumber: {
        value: '',
        option: 1
      },
      rekvnumber: {
        value: '',
        option: 1
      }
    },
    delivery: {
      delivery: {
        start: '',
        end: ''
      },
      production: {
        start: '',
        end: ''
      },
      pickup: {
        start: '',
        end: ''
      },
      transport: 0
    },
    vehicle: {
      regnumber: {
        value: '',
        option: 1
      },
      brand: {
        value: '',
        option: 1
      },
      model: {
        value: '',
        option: 1
      },
      year: {
        value: '',
        option: 1
      }
    },
    color: {
      color: {
        value: '',
        option: 1
      },
      code: {
        value: '',
        option: 1
      },
      ctype: {
        value: '',
        option: 1
      },
      amount: {
        value: '',
        option: 1
      }
    },
    customer: {
      name: {
        value: '',
        option: 1
      },
      city: {
        value: '',
        option: 1
      },
      zipcode: {
        value: '',
        option: 1
      },
      phone: {
        value: '',
        option: 1
      },
      contact_name: {
        value: '',
        option: 1
      }
    },
    invoice: {
      notApprovedForInvoicing: false,
      approvedForInvoicing: false,
      isInvoiced: false
    },
    economicfilter: {
      economicFilterNotMatched: false,
      economicFilterMatched: false
    },
    additionalreport: {
      awaiting: false,
      received: false
    },
    movedOrders: true,
    parts: {
      bodyNotOrdered: false,
      bodyOrdered: false,
      bodyInStock: false,
      bodyArrived: false,
      paintNotOrdered: false,
      paintOrdered: false,
      paintInStock: false,
      paintArrived: false
    },
    HasPaintWork: true,
    HasBodyWork: true,
    NewOrdersFilter: 0
  },
  simplesearch: {
    save: true,
    value: ''
  },
  simplesearchWorkscreen: {
    save: true,
    value: ''
  }
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_ORDER:
      return {
        ...state,
        order: action.order
      }
    case SET_ORDER_BOOKING_TIMES:
      const combineDateTime = (obj) => obj.Date.replace('00:00:00', obj.Time)
      let data = { ...state, order: { ...state.order } }
      let { Body, Paint } = action.data
      console.log('SET_ORDER_BOOKING_TIMES:', Body, Paint)
      if (Body !== null) {
        if (Body.Pickup !== null) data.order.BodyShopPickupTime = combineDateTime(Body.Pickup)
        if (Body.Production !== null) data.order.BodyShopProductionTime = combineDateTime(Body.Production)
        if (Body.Delivery !== null) data.order.BodyShopDeliveryTime = combineDateTime(Body.Delivery)
      }
      if (Paint !== null) {
        if (Paint.Pickup !== null) data.order.Pickup = combineDateTime(Paint.Pickup)
        if (Paint.Production !== null) data.order.ProductionDate = combineDateTime(Paint.Production)
        if (Paint.Delivery !== null) data.order.Delivery = combineDateTime(Paint.Delivery)
      }
      return data
    case SET_WORKCARD_ORDER:
      return {
        ...state,
        workcardOrder: action.order
      }
    case SET_ORDERS:
      if (action.orders === undefined && action.newUpdatedOrder !== undefined) {
        let updatedOrders = JSON.parse(JSON.stringify(state.orders))
        // console.log('action.newUpdatedOrderGroupIndex', action.newUpdatedOrderGroupIndex)
        // console.log('action.newUpdatedOrderItemIndex', action.newUpdatedOrderItemIndex)
        updatedOrders[action.newUpdatedOrderGroupIndex].Orders[action.newUpdatedOrderItemIndex] = action.newUpdatedOrder
        return {
          ...state,
          orders: updatedOrders
        }
      } else {
        return {
          ...state,
          orders: action.orders
        }
      }
    case SET_WORKSCREEN_ORDERS:
      if (action.orders === undefined && action.newUpdatedOrder !== undefined) {
        let updatedOrders = JSON.parse(JSON.stringify(state.orders))
        // console.log('action.newUpdatedOrderGroupIndex', action.newUpdatedOrderGroupIndex)
        // console.log('action.newUpdatedOrderItemIndex', action.newUpdatedOrderItemIndex)
        updatedOrders[action.newUpdatedOrderGroupIndex].Orders[action.newUpdatedOrderItemIndex] = action.newUpdatedOrder
        return {
          ...state,
          workscreenOrders: updatedOrders
        }
      } else {
        return {
          ...state,
          workscreenOrders: action.orders
        }
      }
    case SET_ORDERS_SEARCH:
      return {
        ...state,
        isSearching: action.isSearching
      }
    case SET_ORDERS_ERRORS:
      return {
        ...state,
        errors: action.error
      }
    // case SET_ORDER_FILTER:
    //   return {
    //     ...state,
    //     filter: action.filter
    //   }
    case SET_ORDERLIST_FILTER:
      return {
        ...state,
        filterOrderlist: action.filter
      }
    case SET_WORKSCREEN_ORDER_FILTER:
      return {
        ...state,
        filterWorkscreen: action.filter
      }
    case SET_CUSTOMER_ORDER_FILTER:
      return {
        ...state,
        filterCustomer: action.filter
      }
    case SET_WP_ORDER_FILTER:
      return {
        ...state,
        filterWP: action.filter
      }
    // case RESET_ORDER_FILTER:
    //   let newFilter = JSON.parse(JSON.stringify(initialState.initialFilter))
    //   window.localStorage.setItem('ordersFilter', JSON.stringify(initialState.initialFilter))
    //   // newFilter.process.Completed = true
    //   return {
    //     ...state,
    //     filter: newFilter
    //   }
    case RESET_ORDERLIST_FILTER:
      let newOrderListFilter = JSON.parse(JSON.stringify(initialState.initialFilterOrderlist))
      window.localStorage.setItem('filterOrderlist', JSON.stringify(initialState.initialFilterOrderlist))
      return {
        ...state,
        filterOrderlist: newOrderListFilter
      }
    case RESET_WORKSCREEN_ORDER_FILTER:
      let newWorkscreenOrdersFilter = JSON.parse(JSON.stringify(initialState.initialFilterWorkscreen))
      window.localStorage.setItem('filterWorkscreen', JSON.stringify(initialState.initialFilterWorkscreen))
      return {
        ...state,
        filterWorkscreen: newWorkscreenOrdersFilter
      }
    case RESET_CUSTOMER_ORDER_FILTER:
      let newCustomerOrdersFilter = JSON.parse(JSON.stringify(initialState.initialFilterCustomer))
      window.localStorage.setItem('filterCustomer', JSON.stringify(initialState.initialFilterCustomer))
      return {
        ...state,
        filterCustomer: newCustomerOrdersFilter
      }
    case RESET_WP_ORDER_FILTER:
      let newWPOrdersFilter = JSON.parse(JSON.stringify(initialState.initialFilterWP))
      window.localStorage.setItem('filterWP', JSON.stringify(initialState.initialFilterWP))
      return {
        ...state,
        filterWP: newWPOrdersFilter
      }
    case SET_SIMPLESEARCH:
      return {
        ...state,
        simplesearch: action.simplesearch
      }
    case SET_SIMPLESEARCH_WORKSCREEN:
      return {
        ...state,
        simplesearchWorkscreen: action.simplesearch
      }
    case RESET_SIMPLESEARCH:
      let simpleSearch = { save: true, value: '' }
      window.localStorage.setItem('simpleSearch', JSON.stringify(simpleSearch))
      return {
        ...state,
        simplesearch: {
          save: true,
          value: ''
        }
      }
    case RESET_SIMPLESEARCH_WORKSCREEN:
      let simplesearchWorkscreen = { save: true, value: '' }
      window.localStorage.setItem('simplesearchWorkscreen', JSON.stringify(simplesearchWorkscreen))
      return {
        ...state,
        simplesearchWorkscreen: {
          save: true,
          value: ''
        }
      }
    case SET_LAST_VISITED_ORDER:
      let parsed = parseInt(action.orderId)
      return {
        ...state,
        lastVisitedOrderId: isNaN(parsed) ? undefined : parsed
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/orders.js